function firstPipelineStage(stages, pipelineId) {
    return stages.find(stage => stage.pipeline.id === pipelineId);
}
export { firstPipelineStage };
